<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-toolbar color="primary" fxLayoutAlign="space-between center" fxLayout="row">
    <h1 mat-dialog-title>{{ searchDisplayName$ | async }}</h1>
    <button mat-icon-button
            matTooltip="Reselect Search"
            (click)="back.emit($event)">
        <mat-icon svgIcon="back"></mat-icon>
    </button>
</mat-toolbar>
<form [formGroup]="criteriaFormGroup" (ngSubmit)="search()">
    <mat-dialog-content fxLayout="column" class="md-padding">
        <ng-container *ngIf="criteria$ | async as criteriaModel">
            <dash-gis-criteria-form [criteria]="criteriaModel" [criteriaFormGroup]="criteriaFormGroup"></dash-gis-criteria-form>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions fxLayoutAlign="end center">
        <button mat-button type="submit">Search</button>
        <button mat-button type="button" (click)="cancel()">Cancel</button>
    </mat-dialog-actions>
</form>
